module.exports = __webpack_public_path__ + "img/2012-08-18 13.26.21.166b228a.jpg";